import { render, staticRenderFns } from "./UploadInput.vue?vue&type=template&id=4c2cb326&scoped=true&"
import script from "./UploadInput.vue?vue&type=script&lang=js&"
export * from "./UploadInput.vue?vue&type=script&lang=js&"
import style0 from "./UploadInput.vue?vue&type=style&index=0&id=4c2cb326&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c2cb326",
  null
  
)

export default component.exports